import React from 'react';
import { object } from 'prop-types';
import { get, map, orderBy } from 'lodash';
import JumboLogo from '../../assets/images/jumbo_logo.png';
import Table from '../../src/components/pdf-commons/Table';
import Text from '../../src/components/pdf-commons/Text';
import OrderPdfWrapper from '../../src/components/pdf-commons/OrderPdfWrapper';
import { getItemQuantity, orderInPicking } from '../../src/utils/misc';
import { ProductPrice, HasPermissions, NotFound, Row, Column } from '../../src/components/common';
import { urlSisa, urlBase } from './../../src/components/utils/changeUrlSisa';
import SisaLogo from './../../assets/images/sisa.png';

const OrderList = ({ match }) => {
    const orderId = get(match, 'params.id', null);
    let changeUrl = false;

    if (urlSisa() == urlBase()) {
        changeUrl = true;
    }

    return (
        <HasPermissions
            to={['order-detail-page:view']}
            otherwise={<NotFound firstTextLine='Página no encontrada' style={{ minHeight: '90vh' }} />}
        >
            <OrderPdfWrapper orderId={orderId}>
                {
                    ({ data, orderItems, itemsAddedByClient, unpickedFromStore }) => {
                        const withPicking = orderInPicking(get(data, 'assignInfo.status.code'));
                        const info = {
                            headers: [
                                { key: 'quantity', value: 'Unidades' },
                                { key: 'ean', value: 'EAN' },
                                { key: 'name', value: 'Descripción' },
                                { key: 'brandName', value: 'Marca' },
                                { key: 'price', value: 'Precio unitario' },
                                { key: 'customerNotes', value: 'Observaciones del cliente' },
                                { key: 'shopperNotes', value: 'Observaciones del picking' }
                            ],
                            body: map(withPicking ? [...orderItems, ...orderBy(unpickedFromStore, 'brandName', 'asc')] : [...get(data, 'items', []), ...itemsAddedByClient], ({
                                quantity,
                                name,
                                brandName,
                                customerNotes,
                                unit,
                                unitMultiplier,
                                ean,
                                sellingPrice,
                                listPrice,
                                priceTags
                            }) => {
                                return {
                                    quantity: getItemQuantity({ quantity, unitMultiplier, unit }),
                                    ean,
                                    name,
                                    brandName,
                                    customerNotes,
                                    price: <ProductPrice item={{ unitMultiplier, sellingPrice, listPrice, priceTags }} />
                                };
                            })
                        };

                        return (
                            <>
                                <Row mB={20}>
                                    <Column direction='row' flex={3}>
                                        <Text text='Control interno de pedido&nbsp;' size={20} strong />
                                        <Text text={`Nº ${orderId}`} size={20} strong color={changeUrl ? '#f03434' : '#1fa02e'} />
                                    </Column>
                                    <Column align='flex-end' justify='center'>
                                        <img src={changeUrl ? SisaLogo : JumboLogo} height='19' width='100' />
                                    </Column>
                                </Row>
                                <Table headers={info.headers} body={info.body} />
                            </>
                        );
                    }
                }
            </OrderPdfWrapper>
        </HasPermissions>
    );
};

OrderList.propTypes = {
    match: object
};

export default OrderList;
